export default __webpack_public_path__ + "3d5989a999b39c28d74949d7d8840d91.svg";